import React from 'react'
import CommonOrder from '../commonorder/CommonOrder'

const CrashOrder = () => {
  return (
    <>
     <CommonOrder/>
     <CommonOrder/>
     <CommonOrder/>
     <CommonOrder/>
    </>
  )
}

export default CrashOrder